export var ADD_REPO_RESPONSE = "ADD_REPO_RESPONSE";
export var ADD_ISSUE_RESPONSE = "ADD_ISSUE_RESPONSE";
export var ADD_COLLAB_RESPONSE = "ADD_COLLAB_RESPONSE";
export var ADD_COMMENT_RESPONSE = "CLOSE_ISSUE_RESPONSE";
export var CLOSE_ISSUE_RESPONSE = "CLOSE_ISSUE_RESPONSE";
export var SHOW_LAST_COMMENT_RESPONSE = "SHOW_LAST_COMMENT_RESPONSE";
export var VIEW_REPO_RESPONSE = "VIEW_REPO_RESPONSE";
export var COMMAND = "COMMAND";
export var CLEAR_HISTORY = "CLEAR_HISTORY";
var AddRepoResponse = /** @class */ (function () {
    function AddRepoResponse() {
        this.type = ADD_REPO_RESPONSE;
    }
    return AddRepoResponse;
}());
export { AddRepoResponse };
var AddIssueResponse = /** @class */ (function () {
    function AddIssueResponse(payload) {
        this.payload = payload;
        this.type = ADD_ISSUE_RESPONSE;
    }
    return AddIssueResponse;
}());
export { AddIssueResponse };
var AddCollabResponse = /** @class */ (function () {
    function AddCollabResponse(payload) {
        this.payload = payload;
        this.type = ADD_COLLAB_RESPONSE;
    }
    return AddCollabResponse;
}());
export { AddCollabResponse };
var AddCommentResponse = /** @class */ (function () {
    function AddCommentResponse(payload) {
        this.payload = payload;
        this.type = ADD_COMMENT_RESPONSE;
    }
    return AddCommentResponse;
}());
export { AddCommentResponse };
var CloseIssueResponse = /** @class */ (function () {
    function CloseIssueResponse(payload) {
        this.payload = payload;
        this.type = CLOSE_ISSUE_RESPONSE;
    }
    return CloseIssueResponse;
}());
export { CloseIssueResponse };
var ShowLastCommentResponse = /** @class */ (function () {
    function ShowLastCommentResponse(payload) {
        this.payload = payload;
        this.type = SHOW_LAST_COMMENT_RESPONSE;
    }
    return ShowLastCommentResponse;
}());
export { ShowLastCommentResponse };
var ViewRepoResponse = /** @class */ (function () {
    function ViewRepoResponse(payload) {
        this.payload = payload;
        this.type = VIEW_REPO_RESPONSE;
    }
    return ViewRepoResponse;
}());
export { ViewRepoResponse };
var Command = /** @class */ (function () {
    function Command(payload) {
        this.payload = payload;
        this.type = COMMAND;
    }
    return Command;
}());
export { Command };
var ClearHistory = /** @class */ (function () {
    function ClearHistory(payload) {
        this.payload = payload;
        this.type = CLEAR_HISTORY;
    }
    return ClearHistory;
}());
export { ClearHistory };
//# sourceMappingURL=cards.actions.js.map